/**
 * TV-appene viser jummah-teksten under hver jummah-tid på maks to linjer og
 * kutter resten med «…». Målt på TV-ene: med to eller flere jummah-tider får
 * det plass ca. 36 tegn, med én tid ca. 80 tegn.
 */
export const JUMMAH_INFO_LIMIT_MULTIPLE = 35;
export const JUMMAH_INFO_LIMIT_SINGLE = 80;

export const JUMMAH_INFO_TV_HINT =
  "Teksten blir kuttet på TV-skjermen (vises på maks to linjer).";

/** Myk tegngrense for jummah-teksten, gitt antall jummah-tider moskeen har. */
export const jummahInfoLimit = (jummahCount: number): number =>
  jummahCount > 1 ? JUMMAH_INFO_LIMIT_MULTIPLE : JUMMAH_INFO_LIMIT_SINGLE;

/** True når teksten blir kuttet på TV-en (lagring er fortsatt lov). */
export const isJummahInfoTooLong = (info: string, jummahCount: number) =>
  info.length > jummahInfoLimit(jummahCount);
